const {h, render, Component} = require('preact');

class PreChat extends Component {
  constructor(props) {
    super(props);
    this.handleClosePopupEvent = this.handleClosePopupEvent.bind(this)
  }

   handleClosePopupEvent(){
    this.props.handleClose()
  }

  render() {
    return (
      <div>
        <div class="prechat-header">
          <span class="prechat-title">{I18n.translate('js.modules.web_2018.chat_with_agent')}</span>
          <span class="icon-x bc-end-chat" id="bc-close-chat" onClick={this.handleClosePopupEvent} data-bhw="web_2018_chat_create_ticket"></span>
        </div>
        <div class="bc-busy bc-hidden">
          <div class="bc-busy-img gig-spinner gig-spinner-prim" aria-label="Spinner"></div>
        </div>
      </div>
    )
  }
}

module.exports = PreChat
